function Footer(){
    return (
        <div className="container py-3 box-shadow" id="footer">
            <footer className="border-top">
                <div className="row flex-wrap flex-column flex-md-row justify-content-center align-items-center mt-0">
                <div className="col-10 col-md-3 d-flex justify-content-center justify-content-md-start order-1 order-md-0">
                    <a
                    className="text-body-secondary"
                    href={process.env.PUBLIC_URL + "/adatkezeles.pdf"}
                    target="_blank"
                    rel="noreferrer"
                    >
                    Adatkezelés
                    </a>
                </div>
                <div className="col-10 col-md-4 d-flex justify-content-center align-items-center order-0 order-md-1">
                    <span className="mb-md-0 text-body-secondary">
                    © {new Date().getFullYear()} Egészség Energia Egyensúly
                    </span>
                </div>
                <ul className="col-10 col-md-3 nav justify-content-center justify-content-md-end list-unstyled d-flex order-2 order-md-2">
                    <li className="ms-3">
                    <a
                        className="text-body-secondary footer-icon-holder"
                        href="https://www.instagram.com/egeszsegenergiaegyensuly"
                    >
                        <i className="bi bi-instagram footer-icon" />
                    </a>
                    <a
                        className="text-body-secondary footer-icon-holder"
                        href="https://www.facebook.com/profile.php?id=100086488571841"
                    >
                        <i className="bi bi-facebook footer-icon" />
                    </a>
                    <a
                        className="text-body-secondary footer-icon-holder"
                        href="https://www.facebook.com/groups/1195232611808323"
                    >
                        <i className="bi bi-people-fill footer-icon" />
                    </a>
                    </li>
                </ul>
                </div>
                <div className="row flex-wrap justify-content-center align-items-center">
                <div className="col-12 col-md-10 d-flex justify-content-center align-items-center border-top">
                    <span className="mb-md-0 text-body-tertiary text-center notice">
                    Jelen oldal üzemeltetője a jogvédett tartalmakat, ezen belül, de nem
                    kizárólagosan a Bowen® és a Bowtech® logót és megjelölést a BTAA, és a
                    BTAE, illetve ezen szervezetek magyarországi képviselőjének
                    engedélyével használja.
                    </span>
                </div>
                </div>
            </footer>
        </div>
    );
}

export default Footer;